shadow$provide[263] = function(require,module,exports) {
var require$_DOT__SLASH_text_DOT_js = require("./text.js");
var require$_DOT__SLASH_format_DOT_js = require("./format.js");
var require$_DOT__SLASH_label_DOT_js = require("./label.js");
var require$_DOT__SLASH_retext_DOT_js = require("./retext.js");
require.exportCopy(module, require$_DOT__SLASH_text_DOT_js);
require.exportCopy(module, require$_DOT__SLASH_format_DOT_js);
require.exportCopy(module, require$_DOT__SLASH_label_DOT_js);
require.exportCopy(module, require$_DOT__SLASH_retext_DOT_js);

};